<template>
  <div class="container" id="jobs">
    <h2 class="title">Jobs</h2>
    <div class="content-buttons">
      <md-button
        v-for="(button, index) in buttons"
        :key="index"
        @click="changeCategory(button.name)"
        :class="button.active ? 'md-raised' : ''"
      >
        {{ button.name }}
      </md-button>
    </div>
    <div class="list-jobs">
      <md-card
        v-for="projeto in projetos"
        :key="projeto.id"
        v-show="projeto.category === activeCategory"
        data-aos="flip-left"
        data-aos-offset="100"
        data-aos-delay="500"
        data-aos-duration="1000"
      >
        <md-card-media>
          <a
            :href="projeto.url"
            rel="noopener"
            target="_blank"
            :title="projeto.title"
          >
          </a>
          <img :src="require(`@/assets/${projeto.img}`)" :alt="projeto.name" />
        </md-card-media>
        <md-card-header>
          <h2>{{ projeto.name }}</h2>
          <span>{{ projeto.desc }}</span>
        </md-card-header>
        <md-card-actions>
          <div v-if="projeto.url">
            <a
              :href="projeto.url"
              rel="noopener"
              target="_blank"
              :title="projeto.title"
            >
              <md-button>Visitar Projeto</md-button>
            </a>
          </div>
          <div v-else>
            <a
              data-fancybox="gallery"
              :href="require(`@/assets/${projeto.img}`)"
            >
              <md-button>Ver imagem</md-button>
            </a>
          </div>
        </md-card-actions>
      </md-card>
    </div>
    <p class="small">
      Projetos ( sites ) desenvolvidos para a empresa Asus
      <a href="https://www.asus.com/br/" class="asus" target="_blank">
        (https://www.asus.com/br/)</a
      >, pode ser visualizados no site descrito.
    </p>
  </div>
</template>
<script>
import store from "@/storeData.js";

export default {
  data() {
    return {
      buttons: [
        { name: "recentes", active: true },
        { name: "mais antigos", active: false }
      ],
      projetos: store.projetos,
      activeCategory: "recentes"
    };
  },
  methods: {
    changeCategory(value) {
      this.buttons.forEach(item => {
        if (item.name == value) {
          item.active = true;
          this.activeCategory = value;
        } else {
          item.active = false;
        }
      });
    }
  }
};
</script>
